import { UIComponentState, UIComponentProps, UIComponentImpl, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { DefaultViewImpl } from './defaultview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { DefaultCSSStyleImpl } from './defaultcss';

export interface DefaultComponentProps extends UIComponentProps
{
    status: string;
}


export class DefaultComponent extends UIComponentImpl<DefaultComponentProps, UIComponentState, UIDataModel>
{
    constructor(props: DefaultComponentProps)
    {
        super(props);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new DefaultViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new DefaultCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/navigation/default/defaultcomponent.tsx